<template>
  <div>
    <van-cell-group title="审批人" :border="true" size="large">
      <!-- <div v-for="(items,index) in approvers" :key="index" > -->
      <div class="approvers" v-for="(items, i) in approvers" :key="i">
        <van-row type="flex" justify="center" class="approver">
          <van-col span="8" v-for="(approver, y) in items" :key="approver.id">
            <div class="img-box">
              <van-image
                round
                width="4rem"
                height="4rem"
                :src="approver.thumb_avatar"
              />
              <span class="image-remove" @click="removeApprover(i, y)">+</span>
            </div>

            <h3>{{ approver.name }}</h3>
            <p>{{ approver.position }}</p>
          </van-col>
        </van-row>

        <van-divider />
      </div>
      <van-row type="flex" justify="center" class="approver">
        <van-col span="8">
          <van-button
            icon="plus"
            type="primary"
            @click="user.show = true"
            native-type="button"
            >添加审批人</van-button
          >
        </van-col>
      </van-row>
    </van-cell-group>
    <!-- <van-popup  position="bottom" v-model="user.show">
    <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
    <van-picker 
      cancel-button-text='取消' 
      value-key="name"    
      show-toolbar 
      :columns="user.data"  
      @confirm="addApprover"
      @cancel="user.show = false"
  />
  </van-popup> -->
    <mu-dialog
      transition="slide-bottom"
      fullscreen
      lock-scroll
      scrollable
      :open.sync="user.show"
    >
      <mu-paper :z-depth="1" class="demo-list-wrap">
        <div class="user_top">
          <mu-appbar color="indigo500">
            通讯录
            <mu-button icon slot="right">
              <!-- <mu-icon :value="close"></mu-icon> -->
              <van-icon name="close" @click="user.show = false" />
            </mu-button>
          </mu-appbar>

          <van-search
            placeholder="请输入用户姓名"
            v-model="userForm.user"
            @input="getUser()"
          />
        </div>
        <div class="user_content">
          <mu-list v-for="(items, key) in user.data" :key="key">
            <mu-sub-header>{{ key }}</mu-sub-header>
            <mu-list-item
              avatar
              button
              :ripple="false"
              v-for="item in items"
              :key="item.userid"
              @click="addApprover(item)"
            >
              <mu-list-item-action>
                <mu-avatar>
                  <img :src="item.thumb_avatar" />
                </mu-avatar>
              </mu-list-item-action>
              <mu-list-item-title>{{ item.name }}</mu-list-item-title>
              <mu-list-item-sub-title>{{
                item.position
              }}</mu-list-item-sub-title>
              <!-- <mu-list-item-action>
              <mu-icon :value="item.position"></mu-icon>
            </mu-list-item-action> -->
            </mu-list-item>
            <mu-divider></mu-divider>
          </mu-list>
        </div>
      </mu-paper>
    </mu-dialog>
  </div>
</template>

<script>
export default {
  name: "ApproverFree",
  props: {
    // approvers:Array,
  },
  data() {
    return {
      approvers: [],
      user: {
        show: false,
        data: [],
      },
      userForm: {
        user: "",
      },
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.$http.post("get_users", this.userForm).then((res) => {
        console.log(res);
        this.user.data = res.data.data;
      });
    },
    removeApprover(x, y) {
      console.log(x, y);
      this.approvers[x].splice(y, 1);
      if (this.approvers[x].length == 0) {
        this.approvers.splice(x, 1);
      }
      console.log(this.approvers);
    },

    addApprover(value) {
      this.user.show = false;

      var user = [];
      user.push(value);
      this.approvers.push(user);
      // console.log(this.approvers);
      this.$emit("changeApprover", this.approvers);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers {
  text-align: 0 auto;
  /* display:block; */
  /* margin:10px; */
}
.approver {
  padding: 10px;
}

.approver .van-step {
  display: block;
}
h3 {
  font-size: 12px;
  margin: 5px;
}
p {
  margin: 0px;
  font-size: 12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title {
  background-color: #3f51b5;
  font-size: 14px;
  font-weight: blod;
  color: white;
  padding: 13px;
}

.img-box {
  display: inline-block; /*设置inline-block使img填充div宽高，然后用+定位到右上角，block占据一整行，不能自适应内部元素宽高，inline使宽度自适应，但是无法设置宽高：宽高无效，+就无法定位到右上角*/

  /* border: 1px solid #ececec; */
  position: relative;
}

/* .cover-img{
  max-width: 800px;//设置最大宽度，以免溢出：：：：不要设置百分比80%，否则div会是img的125%，导致+定位到右侧
  min-width: 200px;
} */

.image-remove {
  /* background-color: white; */
  color: #666666;
  font-size: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 100%;
  transform: rotate(45deg);
  cursor: pointer;
  opacity: 0.5;
  top: 0px;
  right: 0px;
  display: block;
  position: absolute;
}
.user_top{
  position:fixed;
  top:0px;
  width:100%;
  z-index:2;
}
.user_content{
  margin-top:110px;
}
.mu-list-item{
  display:block;
}
</style>
